import { useState, useEffect } from "react";
import { InteractionType } from "../types/interactions";

export const useInteractionTypes = () => {
  const [interactionTypes, setInteractionTypes] = useState<InteractionType[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchInteractionTypes = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const response = await fetch("/api/clientphonebook/contactInteractions/getInteractionTypes");

        if (!response.ok) {
          throw new Error(`Failed to fetch interaction types: ${response.statusText}`);
        }

        const types = await response.json();
        setInteractionTypes(types);
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : "Failed to fetch interaction types";
        setError(errorMessage);
        console.error("Error fetching interaction types:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchInteractionTypes();
  }, []);

  return { interactionTypes, isLoading, error };
};
